import { Box, makeStyles, Theme, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import clsx from "clsx";
import { FC } from "react";

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.default,
    boxShadow: `0px 2px 5px ${theme.palette.grey[400]}`,
  },
}));

const Title: FC<{ title: string }> = ({ title }) => (
  <Typography color="textSecondary" variant="h5" style={{ marginBottom: 8 }}>
    {title}
  </Typography>
);

const CustomCard: FC<CustomCardProps> = ({
  withMarginBottom = true,
  padding = 16,
  hasLeftBorder = false,
  height = "inherit",
  width = "100%",
  title,
  externalTitle = true,
  margin = "",
  className,
  children,
}) => {
  const classes = useStyles({});
  const theme = useTheme();
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <>
      {title && externalTitle ? <Title title={title} /> : null}

      <Box
        className={clsx([className, classes.card])}
        style={{
          margin,
          height,
          width: isMd ? "auto" : width,
          padding,
          marginBottom: withMarginBottom ? 16 : 0,
          borderLeft: hasLeftBorder ? `4px solid ${theme.palette.primary.main}` : "",
          borderRadius: 10,
        }}
      >
        {title && !externalTitle ? <Title title={title} /> : null}
        {children}
      </Box>
    </>
  );
};

interface CustomCardProps {
  withMarginBottom?: boolean;
  padding?: string | number;
  hasLeftBorder?: boolean;
  width?: string;
  height?: string;
  title?: string;
  externalTitle?: boolean;
  margin?: string;
  className?: string;
}

export default CustomCard;
